import axios from "axios";
import * as Constants from "../../../constants/Constants";

export function getContact(payload) {
  return new Promise(async (resolve, reject) => {
    axios
    .post(Constants.REACT_APP_API_URL + "api/" + Constants.CONTACT, payload, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function handleExportContact() {
  return new Promise(async (resolve, reject) => {
    axios
    .get(Constants.REACT_APP_API_URL + "api/" + Constants.EXPORTUSER, {
        responseType: "blob", // Set response type to blob for file download
        headers: {
          "content-type": "application/json",
        },
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data])); // Create a URL for the blob
        const link = document.createElement("a"); // Create a link element
        link.href = url; // Set the link's href to the blob URL
        link.setAttribute("download", "users.xlsx"); // Set the download attribute with a filename
        document.body.appendChild(link); // Append the link to the body
        link.click(); // Programmatically click the link to trigger the download
        link.remove(); // Remove the link after triggering the download
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// export function handleExportContact() {
//   return new Promise(async (resolve, reject) => {
//     const token = localStorage.getItem('token'); // Retrieve the token from local storage
//     axios
//       .get("http://localhost:9002/api/admin/users", {
//         responseType: 'blob', // Set response type to blob for file download
//         headers: {
//           "content-type": "application/json",
//           "Authorization": `Bearer ${token}`, // Include the token in the headers
//         },
//       })
//       .then((res) => {
//         const url = window.URL.createObjectURL(new Blob([res.data])); // Create a URL for the blob
//         const link = document.createElement('a'); // Create a link element
//         link.href = url; // Set the link's href to the blob URL
//         link.setAttribute('download', 'users.xlsx'); // Set the download attribute with a filename
//         document.body.appendChild(link); // Append the link to the body
//         link.click(); // Programmatically click the link to trigger the download
//         link.remove(); // Remove the link after triggering the download
//         resolve(res);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
